import React from "react";
import { BrowserRouter, Route } from "react-router-dom";
import NewOrderContainer from "./containers/NewOrderContainer";
import OrderHistoryContainer from "./containers/OrderHistoryContainer";
import TimeoutContainer from "./containers/TimeoutContainer";
import InvoicingContainer from "./containers/InvoicingContainer";
import ErrorHandlerContainer from "./containers/ErrorContainer";
import AdministrationContainer from "./containers/AdministrationContainer";
import ConfigurationContainer from "./containers/ConfigurationContainer";
import NewReturnContainer from "./containers/NewReturnContainer";

function App() {
  return (
    <BrowserRouter>
      <TimeoutContainer>
        <ErrorHandlerContainer>
          <Route exact path="/orderHistory" component={OrderHistoryContainer} />
          <Route exact path="/invoicing" component={InvoicingContainer} />
          <Route exact path="/newOrder" component={NewOrderContainer} />
          <Route exact path="/newReturn" component={NewReturnContainer} />
          <Route exact path="/admin" component={AdministrationContainer} />
          <Route exact path="/config" component={ConfigurationContainer} />
        </ErrorHandlerContainer>
      </TimeoutContainer>
    </BrowserRouter>
  );
}

export default App;
